import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSpareForwardings, SpareForwarding } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './spareForwardingsModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SpareForwarding> useData={useSpareForwardings} config={config} />;
};

export default List;
